import React from 'react';
import styled from 'styled-components';
import dt from '../../../shared/theme';
import { incomeSeriesPropTypes } from '../common/prop-types';
import useFundsStateStore from '../common/funds-state-hook';
import { Description, Name, Results } from './hero-components/styles';

const Banner = styled.div`
  display: flex;
  flex-direction: row-reverse;
  justify-content: space-between;
  align-items: start;
  background-repeat: round;
  background-size: cover;
  background-image: url(${props => props.incomeSeriesBackground});
  padding: 32px 28px;
  width: 100%;
  z-index: 210;

  ${props => dt(props).theme.isXLarge && `
    padding: 32px calc(50% - 476px);
  `};

  ${props => dt(props).theme.isXXLarge && `
    padding: 32px calc(50% - 600px);
  `};

  ${props => dt(props).theme.isMobile && `
    background-repeat: unset;
    flex-direction: column;
    padding: 36px 20px 40px;
    background-image: url(${props.incomeSeriesBackground});
  `};
`;

const Logo = styled.img`
  max-width: 300px;
  margin-top: 20px;

  ${props => dt(props).theme.isMobileOrTablet && `
    max-width: 33%;
  `};

  ${props => dt(props).theme.isMobile && `
    margin-left: auto;
    margin-bottom: 28px;
    margin-top: 0;
    max-height: 44px;
  `};
`;

const Primary = styled.div`
  display: flex;
  flex-direction: column;
  max-width: 520px;

  ${props => dt(props).theme.isMobileOrTablet && `
    max-width: 372px;
  `};

  ${props => dt(props).theme.isMobile && `
    max-width: 100%;
  `};
`;

const ViewSeriesLink = styled.a`
  border: 1px solid ${props => dt(props).theme.primaryColor};
  border-radius: 4px;
  color: ${props => dt(props).theme.primaryColor};
  font-size: 16px;
  font-family: ${props => dt(props).theme.fontFamilyBody};
  font-weight: ${props => dt(props).theme.fontWeightHeavy};
  text-transform: uppercase;
  margin-top: 24px;
  width: 165px;
  height: 40px;
  background: transparent;
  text-align: center;
  padding-top: 11px;

  ${props => dt(props).theme.isMobile && `
    width: 100%;
  `};

  &:hover {
    text-decoration: none !important;
    cursor: pointer;
  }
`;

const INCOME_SERIES_URL = 'https://incomeseries.livewiremarkets.com/?utm_campaign=Income+Series+2021&utm_medium=livewire+website&utm_source=engagement+campaign&utm_content=listings+page+banner&utm_term=';

export default function IncomeSeriesHero({
  incomeSeriesBackground,
  incomeSeriesLogoHorizontal,
}) {
  const totalResults = useFundsStateStore(state => state.totalResults);
  const resultsText = totalResults !== null ? `${totalResults} Result${totalResults === 1 ? '' : 's'}` : null;

  return (
    <Banner incomeSeriesBackground={incomeSeriesBackground}>
      <Logo src={incomeSeriesLogoHorizontal} />
      <Primary>
        {!!resultsText && <Results>{resultsText}</Results>}
        <Name>Livewire Income Series</Name>
        <Description>
          Discover the best income focused funds, ETFs and LICs/LITs on Livewire by asset class,
          understand their fee structure and see how they perform.
        </Description>
        <ViewSeriesLink href={INCOME_SERIES_URL}>View The Series</ViewSeriesLink>
      </Primary>
    </Banner>
  );
}

IncomeSeriesHero.propTypes = incomeSeriesPropTypes;
